$(function () {
    var body = $('body');
    var main = $('main');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li > a, ul li > button');
    var megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu > a, ul li.menu-item-has-megamenu > button');
    var megamenu_window = $('.Megamenu');
    var megamenu_navlist = $('.megamenu-nav-list');
    var megamenu_parent = $('.megamenu-column-one');
    var break_point = 1200;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var browser_width = window.innerWidth;
    
    var searchToggle = $('.searchToggleTrigger');
    var searchBar = $('.searchBarElement');
    var searchBarFocusElement = $('.searchBarFocus');
    var wrapper = $('.searchBarElement');
    var searchBarHidden = true;
    var main = $('main');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                nav_trigger.parent().removeClass('__active');
                megamenu_trigger.parent().removeClass('__active');
                megamenu_window.removeClass('__active');
                nav_wrap.find('ul').removeClass('__subopen');
                $('.menu-item-has-megamenu>button').attr('aria-expanded', false);
            }
        }
    });


    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
            megamenu_window.parent().removeClass('__active');
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('.__active').removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
        nav_wrap.find('ul').removeClass('__subopen');
        megamenu_window.parent().removeClass('__active');
        megamenu_navlist.removeClass('__active');
        megamenu_parent.removeClass('__active');

    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    searchToggle.click(function(event) {
        event.preventDefault();
        searchBarHidden = !searchBarHidden;
        $(this).toggleClass('__active');
        nav_reset();
        if (searchBarHidden) {
            searchBar.find('*[tabindex=0]').attr('tabindex', '-1');
            searchToggle.focus();
            wrapper.slideUp(200);
            main.removeClass('__bg-blur');
        } else {
            searchBar.find('*[tabindex=-1]').attr('tabindex', '0');
            searchBarFocusElement.focus();
            wrapper.slideDown(200);
            main.addClass('__bg-blur');
        }
    });

    function initMenu() {
        
        browser_width = window.innerWidth;

        // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {

            nav_wrap.focusin(function () {
                $('.hoverbar').css('opacity', '1');
            });
            nav_wrap.focusout(function () {
                $('.hoverbar').css('opacity', '0');
            });
            nav_wrap.mouseover(function () {
                $('.hoverbar').css('opacity', '1');
            });
            nav_wrap.mouseout(function () {
                $('.hoverbar').css('opacity', '0');
            });

            nav_trigger.parent().focusin(function () {
                $positionx = $(this).position().left;
                $offset = $('.hoverbar-wrapper').position().left;
                $width = $(this).width();
                $('.hoverbar').css('left', $positionx-$offset+30);
                $('.hoverbar').css('width', $width-60);
            });

            nav_trigger.parent().mouseover(function () {
                $positionx = $(this).position().left;
                $offset = $('.hoverbar-wrapper').position().left;
                $width = $(this).width();
                $('.hoverbar').css('left', $positionx-$offset+30);
                $('.hoverbar').css('width', $width-60);
            });

            nav_trigger.click(function () {
                if(!$(this).hasClass('megamenu-tab-trigger')){
                    if($(this).parent().hasClass('__active')){
                        $(this).parent().removeClass('__active');
                        $(this).parent().children('button').attr('aria-expanded', false);
                        if (!$(this).closest('ul').children('li').hasClass('__active')) {
                            $(this).closest('ul').removeClass('__subopen');
                        }
                    } else {
                        const current_item = $(this).parent();
                        const current_list = $(this).closest('ul');
                        const active_siblings = current_list.children('li.__active').not(current_item);

                        active_siblings.removeClass('__active');
                        active_siblings.children('button').attr('aria-expanded', false);

                        megamenu_trigger.parent().removeClass('__active');
                        megamenu_trigger.parent().children('button').attr('aria-expanded', false);
                        megamenu_trigger.parent().children('.Megamenu').removeClass('__active');
                        current_item.addClass('__active');
                        current_item.children('button').attr('aria-expanded', true);
                        current_list.addClass('__subopen');
                    }
                    if(nav_wrap.find('.nav > ul > li').hasClass('__active')){
                        main.addClass('__bg-blur');
                    } else {
                        main.removeClass('__bg-blur');
                    }
                }
            });

            megamenu_trigger.focusin(function () {
                $positionx = $(this).parent().position().left;
                $offset = $('.hoverbar-wrapper').position().left;
                $width = $(this).parent().width();
                $('.hoverbar').css('left', $positionx-$offset+30);
                $('.hoverbar').css('width', $width-60);
            });
            megamenu_trigger.mouseover(function () {
                $positionx = $(this).parent().position().left;
                $offset = $('.hoverbar-wrapper').position().left;
                $width = $(this).parent().width();
                $('.hoverbar').css('left', $positionx-$offset+30);
                $('.hoverbar').css('width', $width-60);
            });

            megamenu_trigger.click(function () {
                
                if($(this).parent().children('.Megamenu').hasClass('__active')){
                    // Disable all megamenus that might be open
                    $(this).parent().removeClass('__active');
                    $(this).parent().children('button').attr('aria-expanded', false);
                    $(this).parent().children('.Megamenu').removeClass('__active');
                } else {
                    megamenu_trigger.parent().removeClass('__active');
                    megamenu_trigger.parent().children('button').attr('aria-expanded', false);
                    megamenu_trigger.parent().children('.Megamenu').removeClass('__active');
                    nav_trigger.parent().removeClass('__active');
                    nav_trigger.parent().children('button').attr('aria-expanded', false);
                    $(this).parent().addClass('__active');
                    $(this).parent().children('button').attr('aria-expanded', true);
                    $(this).parent().children('.Megamenu').addClass('__active');
                }
                if(nav_wrap.find('.nav > ul > li').hasClass('__active')){
                    main.addClass('__bg-blur');
                } else {
                    main.removeClass('__bg-blur');
                }
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                // event.stopPropagation();
                if ($(this).parent().children('ul').length > 0) {
                    // event.preventDefault();
                    // $(this).parents('ul').removeClass('__active');
                    $(this).parent().children('ul').addClass('__active');
                    $('.navwrap-logo').removeClass('__active');
                }
                if ($(this).parent().children('.Megamenu').length > 0) {
                    $(this).parents('ul').removeClass('__active');
                    $(this).parent().children('.Megamenu').addClass('__active');
                    $('.megamenu-column-one .megamenu-nav-list').addClass('__active');
                    $('.megamenu-column-one').addClass('__active');
                }
                if ($(this).hasClass('megamenu-tab-trigger')) {
                    $('.megamenu-column-two .megamenu-nav-list').addClass('__active');
                    $('.megamenu-column-two').addClass('__active');
                }
            });

            var back_menu = $('.backto');
            back_menu.click(function (event) {
                // event.preventDefault();
                // event.stopPropagation();
                $(this).parent('ul').removeClass('__active');
                $(this).closest('.megamenu').removeClass('__active');
                $(this).parents('li').parent('ul').addClass('__active');
                $(this).closest(megamenu_window.parent()).removeClass('__active');
                $('.megamenu-column-one').removeClass('__active');
                $('.navwrap-logo').addClass('__active');
            });

            var back_menu = $('.backtochild');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).parent('ul').removeClass('__active');
                $(this).parents('li').parent('ul').addClass('__active');
                $(this).closest(megamenu_window.parent()).removeClass('__active');
                $('.megamenu-column-one').removeClass('__active');
            });

            var back_menu_mega = $('.backtomega');
            back_menu_mega.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).closest('.megamenuContent').removeClass('__active');
                $(this).closest(megamenu_window.parent()).addClass('__active');
                $(megamenu_parent).addClass('__active');
                $(megamenu_trigger.parent()).removeClass('__active');
                $('.mobile-menu-title.__main').show();
            });
        }

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }

        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }
    }

    initMenu();

    $(window).on('resize', function () {
        initMenu();
        nav_reset();
        megamenu_window.parent().removeClass('__active');
    });
});

$(function () {
    var break_point = 992;
    var browser_width = window.innerWidth;

    $('.Megamenu').each(function (i, tab) {
        var tabRoot = $(this);
        var tabTrigger = '.megamenuTrigger';
        var tabTriggerMobile = '.megamenuTriggerMobile';
        var tabContent = '.megamenuContent';
        var tabImage = '.megamenuTabImage';
        var findTabTrigger = tabRoot.find(tabTrigger);
        var findTabTriggerMobile = tabRoot.find(tabTriggerMobile);
        var findTabContent = tabRoot.find(tabContent);
        var findTabImage = tabRoot.find(tabImage);

        findTabTrigger.attr('aria-selected', false);
        findTabTriggerMobile.attr('aria-selected', false);
        findTabContent.attr('aria-expanded', false);
        findTabImage.attr('aria-expanded', false);

        findTabTrigger.eq(0).addClass('__active').attr('aria-selected', true);
        findTabTriggerMobile.eq(0).addClass('__active').attr('aria-selected', true);
        findTabContent.eq(0).addClass('__active').attr('aria-expanded', true);
        findTabImage.eq(0).addClass('__active').attr('aria-expanded', true);

        // enable hover on desktop
        if (browser_width >= break_point) {
            findTabTrigger.mouseover(function (e) {
                e.preventDefault();
                var dataSet = $(this).data('set');

                tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                $(this).attr('aria-selected', true).addClass('__active');

                tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

                tabRoot.find(tabImage + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabImage + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

            });
            findTabTrigger.focusin(function (e) {
                e.preventDefault();
                var dataSet = $(this).data('set');

                tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                $(this).attr('aria-selected', true).addClass('__active');

                tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

                tabRoot.find(tabImage + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabImage + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
            });
        }

        else {
            findTabTriggerMobile.click(function (e) {
                var dataSet = $(this).data('set');

                tabRoot.find(tabTriggerMobile + '.__active').attr('aria-selected', false).removeClass('__active');
                $(this).attr('aria-selected', true).addClass('__active');

                tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

                tabRoot.find(tabImage + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabImage + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
            })
        }

        findTabTrigger.click(function (e) {
            $(tabRoot).addClass('__active');
        });

        // mobile meganav tabs in progress
        if (browser_width < break_point) {
            findTabTriggerMobile.click(function (e) {
                $('.megamenu-column-one').removeClass('__active');
            });
        };

    });
});
$(function () {
    $('.header-aux .advice').css("transform", "translateY("+$('body').scrollTop()+"px)");
    $('body').on( "scroll", function() {
        $('.header-aux .advice').css("transform", "translateY("+$('body').scrollTop()+"px)");
    });
    
});
